// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ProgrammingArrowIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ProgrammingArrow/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.792 13.425v-6.85a2.486 2.486 0 0 0 1.875-2.408c0-1.384-1.117-2.5-2.5-2.5a2.497 2.497 0 0 0-2.5 2.5c0 1.166.8 2.133 1.875 2.408v6.842a2.497 2.497 0 0 0 .625 4.917c1.383 0 2.5-1.117 2.5-2.5 0-1.167-.8-2.134-1.875-2.409ZM16.458 13.425V5.417a2.29 2.29 0 0 0-2.291-2.292h-2.442L12.9 2.15a.632.632 0 0 0 .083-.883.632.632 0 0 0-.883-.084L9.6 3.267a.634.634 0 0 0 0 .967l2.5 2.083c.117.1.258.141.4.141a.624.624 0 0 0 .4-1.108l-1.175-.975h2.442c.575 0 1.041.467 1.041 1.042v8.008a2.486 2.486 0 0 0-1.875 2.408c0 1.384 1.117 2.5 2.5 2.5 1.384 0 2.5-1.116 2.5-2.5 0-1.166-.8-2.133-1.875-2.408Z"
}));
export default ProgrammingArrowIcon;